import React from 'react';
import { SupportedLanguage } from '../../../../types/SupportedLanguage';
import { StoreContext } from '../../../../store/StoreContext';
import './LanguageSelector.scss';

export const LanguageSelector  = () => {
  const setLang = (currentLang: SupportedLanguage, targetLang: SupportedLanguage, storeSetLang: (language: SupportedLanguage) => void) => {
    if (currentLang !== targetLang) {
      storeSetLang(targetLang);
    }
  };

  return (
    <StoreContext.Consumer>
      {
        store =>
          <div className="LanguageSelector">
            <p className={`${store.currentLanguage === SupportedLanguage.English ? 'active' : 'hoverable'}`} onClick={() => setLang(store.currentLanguage, SupportedLanguage.English, store.setLanguage)}>EN</p>
            <p>|</p>
            <p className={`${store.currentLanguage === SupportedLanguage.Traditional_Chinese ? 'active' : 'hoverable'}`} onClick={() => setLang(store.currentLanguage, SupportedLanguage.Traditional_Chinese, store.setLanguage)}>繁</p>
            <p>|</p>
            <p className={`${store.currentLanguage === SupportedLanguage.Simplified_Chinese ? 'active' : 'hoverable'}`} onClick={() => setLang(store.currentLanguage, SupportedLanguage.Simplified_Chinese, store.setLanguage)}>简</p>
          </div>
      }
    </StoreContext.Consumer>
  );
};